import React from "react";
import { connect } from "react-redux";
import { LaunchModal } from "MODULES/shared/components";
import Create from "./Create";

export default connect(state => ({
  id: state.partDetail.getIn(["part", "id"])
}))(({ id }) => (
  <LaunchModal
    modal={Create}
    buttonClass="btn-primary btn-hollow pull-right"
    id={id}
  />
));



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/New.jsx